import api from "./api";

export const getPublicKbHome = async () => {
    const res = await api.get("/public/kb/home");
    return res.data;
};

export const searchPublicKbArticles = async (params = {}) => {
    const res = await api.get("/public/kb/articles", { params });
    return res.data;
};

export const getPublicKbArticle = async (slug) => {
    const res = await api.get(`/public/kb/articles/${slug}`);
    return res.data;
};

// Admin / CRM KB
export const getKbCategories = async (includeInactive = true) => {
    const res = await api.get("/kb/categories", {
        params: { includeInactive }
    });
    return res.data;
};

export const createKbCategory = async (payload) => {
    const res = await api.post("/kb/categories", payload);
    return res.data;
};

export const updateKbCategory = async (categoryId, payload) => {
    const res = await api.patch(`/kb/categories/${categoryId}`, payload);
    return res.data;
};

export const getKbArticles = async (params = {}) => {
    const res = await api.get("/kb/articles", { params });
    return res.data;
};

export const getKbArticle = async (articleId) => {
    const res = await api.get(`/kb/articles/${articleId}`);
    return res.data;
};

export const createKbArticle = async (payload) => {
    const res = await api.post("/kb/articles", payload);
    return res.data;
};

export const updateKbArticle = async (articleId, payload) => {
    const res = await api.patch(`/kb/articles/${articleId}`, payload);
    return res.data;
};

export const deleteKbArticle = async (articleId) => {
    const res = await api.delete(`/kb/articles/${articleId}`);
    return res.data;
};